      document.addEventListener('DOMContentLoaded', () => {
        gsap.registerPlugin(ScrollTrigger);

        const hero = document.querySelector('.hero-hero');
        if (!hero) return;

        const stamp = hero.querySelector('.hero-stamp');
        const hand = hero.querySelector('.hero-hand');
        const title = hero.querySelector('.hero-title');
        const text = hero.querySelector('.hero-text');
        const items = [stamp, hand, title, text];
        const stampDelay = 0;
        const handDelay = 0.6;
        const titleDelay = 1.2;
        const textDelay = 1.2;
        gsap.set(items, { y: window.innerHeight, opacity: 0 });
        const intro = gsap.timeline({
          onComplete: () => {
            ScrollTrigger.refresh();
            createScrollAnim();
          },
        });

        intro
          .to(stamp, { y: 0, opacity: 1, duration: 1.2, ease: 'power4.out', delay: stampDelay })
          .to(hand, { y: 0, opacity: 1, duration: 1.2, ease: 'power4.out' }, handDelay)
          .to(title, { y: 0, opacity: 1, duration: 1.0, ease: 'power4.out' }, titleDelay)
          .to(text, { y: 0, opacity: 1, duration: 1.0, ease: 'power4.out' }, textDelay);

        function createScrollAnim() {
          gsap.to(stamp, {
            y: -280,
            scrollTrigger: {
              trigger: hero,
              start: 'top top',
              end: 'bottom top',
              scrub: 1,
              immediateRender: false,
            },
          });

          gsap.to(hand, {
            y: -230,
            scrollTrigger: {
              trigger: hero,
              start: 'top top',
              end: 'bottom top',
              scrub: 1,
              immediateRender: false,
            },
          });

          gsap.to(title, {
            y: -180,
            scrollTrigger: {
              trigger: hero,
              start: 'top top',
              end: 'bottom top',
              scrub: 1,
              immediateRender: false,
            },
          });

          gsap.to(text, {
            y: -140,
            scrollTrigger: {
              trigger: hero,
              start: 'top top',
              end: 'bottom top',
              scrub: 1,
              immediateRender: false,
            },
          });
        }
      });



      function animateIf(selector, animation) {
         if (document.querySelector(selector)) {
    animation();
        }
        }


/* -----------------------------
   LANDING 2 (span words)
--------------------------------*/

animateIf("#span-word-1", () => {
  gsap.from("#span-word-1", {
    y: 500,
    duration: 1.5,
    ease: "power4.out",
    delay: 0.5,
    rotate: 30,
    scrollTrigger: {
      trigger: ".landing-2" ,
    }
});

gsap.to("#span-word-1", { opacity: 1 });
});

animateIf("#span-word-2", () => {
    gsap.from("#span-word-2", {
        y: 500,
        duration: 1.5,
        ease: "power4.out",
        rotate: -30,
        delay: 0.5,
        scrollTrigger: {
            trigger: ".landing-2",
         
    }
  });

  gsap.to("#span-word-2", { opacity: 1 });
});

animateIf(".span-text-wraper", () => {
  gsap.from(".span-text-wraper", {
    y: 500,
    duration: 2.5,
    ease: "power4.out",
    delay: 0.5,
    scrollTrigger: {
      trigger: ".landing-2",
    }
  });

  gsap.to(".span-text-wraper", { opacity: 1 });
  gsap.to(".heading-wrap",
     { overflow: 'visible' , delay :1.5 });
});

animateIf("#span-wrap-1", () => {
  gsap.to("#span-wrap-1", {
    y: -300,
    duration: 3,
    rotate: -2,
    scrollTrigger: {
      trigger: ".landing-2",
      start: "top  top",
      end: "bottom top",
      scrub: 1.2 ,
    }
  });
});

animateIf("#span-wrap-2", () => {
  gsap.to("#span-wrap-2", {
    y: -300,
    duration: 3,
    rotate: 5,
    scrollTrigger: {
      trigger: ".landing-2",
      start: "top  top",
      end: "bottom top",
      scrub: 1.2 ,
    }
  });
});

animateIf(".span-text", () => {
  gsap.to(".span-text", {
    y: -150,
    duration: 5,
        ease: "power4.out",
    scrollTrigger: {
      trigger: ".landing-2",
      start: "top top",
      end: "bottom top",
      scrub: 1.2
    }
  });
});

  
  
  // reel section
  
  const heading = document.querySelector("#reel_word");
  
  const words = heading.textContent
  .trim()
  .split(/\s+/);  
  
  heading.innerHTML = words
  .map(word => `
    <span class="word-wrapper">
    <span class="word">${word}</span>
    </span>
    `)
    .join(" ");
    
    
    
    
    
    
    
    let rl = gsap.timeline({
scrollTrigger: {
  trigger: ".reel-hero",
  start: "top top",
  end: "+=600%",
  scrub: 1.5,
  pin: true,
  pinSpacing: true,
    anticipatePin: 1
}

});

rl.from(".reel-text", {
  yPercent: 100,
  duration: 1,
  ease: "power4.out",


});

rl.from("#reel_word .word", {
 yPercent: 1000   ,
  rotate: 30,
  duration: 10,
  ease: "power4.out",
  stagger: 1.5,
});


rl.to(".reel_slider", {
yPercent: -78   ,
  duration: 10,
  ease: "power4.out"
});


rl.to(".reel_slider .reel", {
  opacity: 1,
  ease: "power1.out"
} , '<');  

// rl.to(".reel_slider", {
//   xPercent: -85,
//   force3D: true,
//   overwrite: "auto",
//   duration: 25,
//   ease: "power4.out"

// });



rl.to(".reel-wrap", {
  yPercent: -120,
  duration: 8,
  ease: "power1.out"
});



// product slider

const product_heading = document.querySelector(".heading_main");

if (product_heading) {
  const product_words = product_heading.textContent.trim().split(/\s+/);
  
  product_heading.innerHTML = product_words
    .map(word => `<span class="productword-wrapper"><span class="productword">${word}</span></span>`)
    .join("");

  gsap.from(".heading_main .productword", {
    y: 350,
    duration: 2,
    ease: "power4.out",
    stagger: 0.5,
  scrollTrigger: {
  trigger: ".product-slider-section",
  start: "top top",
  end: "+=150%",
  scrub: 1,
  pin: true,
  pinSpacing: true,
  anticipatePin: 1
}

  });



}





  // Split words
const about_heading = document.querySelector("#about_word");

const about_words = about_heading.textContent.trim().split(/\s+/);
console.log(about_words)
about_heading.innerHTML = about_words
  .map(about_word => `
    <span class="word-wrapper">
      <span class="word">${about_word}</span>
    </span>
  `)
  .join(" ");


// ABOUT SECTION ANIMATION
ScrollTrigger.matchMedia({

  // MOBILE
  "(max-width: 767px)": function() {
    let al = gsap.timeline({
      scrollTrigger: {
        trigger: ".about-hero",
        start: "top top",
        end: "+=500%",    // shorter distance for small screens
        scrub: 0.8,         // smoother scrub
        pin: true,
        pinSpacing: true,
        anticipatePin: 0    // remove bang effect
      }
    });

    // animations (slightly reduced for mobile)
  
    al.from(".about-text", { yPercent: 10 , 
       duration: 15,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.from("#about_word .word", { yPercent: 350, rotate: 30, stagger: 3.5 ,  duration: 25,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.to(".about_slider", { yPercent: -80 ,  
      duration: 35,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.to(".blog", { opacity: 1, stagger: 0.2 });
  // ⭐ Increase duration here
  al.to(".about_slider", {
    xPercent: -100,
    duration: 105,   // ⬅ increase as much as you want
    ease: "power4.out"
  });
    al.to(".blog_btn", { yPercent: -200 });
  },

  // DESKTOP
  "(min-width: 768px)": function() {
    let al = gsap.timeline({
      scrollTrigger: {
        trigger: ".about-hero",
        start: "top top",
        end: "+=500%",
        scrub: 1.5,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1
      }
    });

    al.from(".about-text", { yPercent: 10 , 
       duration: 15,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.from("#about_word .word", { yPercent: 350, rotate: 30, stagger: 3.5 ,  duration: 25,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.to(".about_slider", { yPercent: -80 ,  
      duration: 35,   // ⬅ increase as much as you want
    ease: "power4.out"});
    al.to(".blog", { opacity: 1, stagger: 0.2 });
  // ⭐ Increase duration here
  al.to(".about_slider", {
    xPercent: -85,
    duration: 45,   // ⬅ increase as much as you want
    ease: "power4.out"
  });
    al.to(".blog_btn", { yPercent: -200 });
  }

});



// // 6️⃣ Move wrap up
// al.to(".about-wrap", {
//   yPercent: -85,
//   duration: 8,
//   ease: "power1.out",
// });





      // join animation
      
      
      
      
      gsap.from(".join-stamp img", {
        y: 200,
        duration: 1,
        ease: "power4.out",
          scrollTrigger: {
            trigger: ".join-hero",
            start :'top 50%',
            end : "+=1000px",
            scrub: 1.5,
          }
      });
      
      
      gsap.from(".join-hand img", {
        y: 200,
          duration: 1,
          scrollTrigger: {
            trigger: ".join-hero",
            start :'top 50%',
            scrub: 1.5, 
          }
          
        } );
        
      
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".join-hero",
            start: "top top",
            end : '+2000px',
            scrub: 1.5,
            pin: true,
            pinSpacing: true ,
              anticipatePin: 1
          }
        });
        
        
        tl.from(".join-title", {
          y: 1000,
          duration: 30,
          ease: "power4.out",
        });
        
        
        // tl.to(".popup_slider", {
        //   yPercent: -70,
        //   duration: 30,
        //   ease: "power4.out",
        // });
        
    
        
        